
import { useLanguage } from '../../../contexts/LanguageContext';
import translations from '../../../i18n/translations';

export default function Services() {
  const { language } = useLanguage();
  const t = translations[language].servicesSection;

  const colors = ['#00A3FF', '#6B46C1', '#FF6B35'];
  const bgColors = ['bg-blue-50', 'bg-purple-50', 'bg-orange-50'];
  const icons = ['ri-grid-line', 'ri-server-line', 'ri-shield-check-line'];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1.5 bg-white text-[#FF6B35] text-xs font-semibold tracking-wider rounded-full mb-4">
            {t.badge}
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t.subtitle}</p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {t.items.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div className="mb-6">
                <div className={`w-24 h-24 ${bgColors[index]} rounded-full flex items-center justify-center mx-auto`}>
                  <i className={`${icons[index]} text-4xl`} style={{ color: colors[index] }}></i>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">{service.title}</h3>

              {/* Subtitle */}
              <p className="text-base italic mb-6 text-center font-medium" style={{ color: colors[index] }}>
                {service.subtitle}
              </p>

              {/* Service List */}
              <ul className="space-y-3">
                {service.items.map((item, idx) => (
                  <li key={idx} className="flex items-start text-sm text-gray-600 leading-relaxed">
                    <span
                      className="inline-block w-1.5 h-1.5 rounded-full mt-2 mr-3 flex-shrink-0"
                      style={{ backgroundColor: colors[index] }}
                    ></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Connection Lines */}
        <div className="mt-12 flex items-center justify-center space-x-4">
          <div className="w-32 h-0.5 border-t-2 border-dashed border-gray-300"></div>
          <div className="w-3 h-3 bg-[#00A3FF] rounded-full"></div>
          <div className="w-32 h-0.5 border-t-2 border-dashed border-gray-300"></div>
          <div className="w-3 h-3 bg-[#6B46C1] rounded-full"></div>
          <div className="w-32 h-0.5 border-t-2 border-dashed border-gray-300"></div>
          <div className="w-3 h-3 bg-[#FF6B35] rounded-full"></div>
          <div className="w-32 h-0.5 border-t-2 border-dashed border-gray-300"></div>
        </div>
      </div>
    </section>
  );
}
